<template>
  <div>
    <Breadcrumbs main="Home" title="My Submission"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid" v-if="data_exists">
      <div class="edit-profile">
        <div class="row">

          <div class="col-xl-8">
            <b-card header-tag="div" no-body>

              <b-card-body >
                <form >
                  <fieldset :disabled="true" class="no-border" >
                  <div class="row">
                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label">Name of Team / Innovation (if any) </label>
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="Team ONE"
                              v-model="data.team_name"
                          />
                        </div>

                      </div>
                    </div>

                    <div class="col-md-12">
                      <label class="col-form-label pt-5">Name of Applicant / Team Leader
                        (As per NID/Birth Certificate/Passport) </label>
                      <div class="form-row">
                        <div class="col-6">
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="First name"
                              v-model="data.description.first_name"

                          />
                        </div>
                        <div class="col-6">
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="Last name"
                              v-model="data.description.last_name"
                          />
                        </div>
                      </div>
                    </div>


                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-5">Primary Email Address</label>
                          <input
                              class="form-control"
                              type="email"
                              required=""
                              placeholder="Test@gmail.com"
                              v-model="data.description.primary_email"
                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-5">Highest Academic Qualification Completed</label>
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="e.g., HSC, BBA in Marketing, MSc in Environmental Science"
                              v-model="data.description.highest_education"

                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-5">Gender</label>
                          <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio3" value="Male" v-model="data.description.gender">Male</b-form-radio>
                            </div>
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio3" value="Female" v-model="data.description.gender">Female</b-form-radio>
                            </div>
                            <br>
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio3" value="Non-binary" v-model="data.description.gender">Non-binary</b-form-radio>
                            </div>
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio3" value="Prefer not to say " v-model="data.description.gender">Prefer not to say </b-form-radio>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-5">Date of Birth</label>
                          <div class="col-6">
                            <datepicker input-class="datepicker-here form-control digits" :format="format" v-model="data.description.date_of_birth" ></datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-5">NID / Student ID / Other Valid ID Number </label>
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="6411xxxxxx"
                              v-model="data.description.id_number"

                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-5">Mobile Number (WhatsApp Enabled) </label>
                          <input
                              class="form-control"
                              type="text"
                              required=""
                              placeholder="01xxxxxxxxxx"
                              v-model="data.description.whatsapp_no"

                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-5">Current Address (District, Upazila) </label>
                          <textarea class="form-control" rows="5"
                                    placeholder="Banani, Dhaka" v-model="data.description.current_address"></textarea>
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-5">Permanent Address (if different) </label>
                          <textarea class="form-control" rows="5"
                                    placeholder="Banani, Dhaka" v-model="data.description.permanent_address"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">

                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-5">Are you applying as a:</label>
                          <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio4" :value="true" v-model="data.description.team">Team</b-form-radio>
                            </div>
                            <div class="radio radio-primary d-inline-block">
                              <b-form-radio name="radio4" :value="false" v-model="data.description.team">Individual</b-form-radio>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-12"  v-if="data.description.team">
                      <label class="col-form-label pt-5">Member 1 </label>
                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-2">Full Name</label>
                          <input
                              class="form-control"
                              type="text"

                              placeholder="Full Name"
                              v-model="data.description.members.member_1.name"

                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Email</label>
                          <input
                              class="form-control"
                              type="text"

                              placeholder="email@gmail.com"
                              v-model="data.description.members.member_1.email"
                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Highest Education</label>
                          <input
                              class="form-control"
                              type="text"

                              placeholder="HSC"
                              v-model="data.description.members.member_1.highest_education"
                          />
                        </div>
                      </div>

                      <label class="col-form-label pt-5">Member 2 </label>
                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-2">Full Name</label>
                          <input
                              class="form-control"
                              type="text"

                              placeholder="Full Name"
                              v-model="data.description.members.member_2.name"

                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Email</label>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="email@gmail.com"
                              v-model="data.description.members.member_2.email"
                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Highest Education</label>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="HSC"
                              v-model="data.description.members.member_2.highest_education"
                          />
                        </div>
                      </div>

                      <label class="col-form-label pt-5">Member 3 </label>
                      <div class="form-row">
                        <div class="col-6">
                          <label class="col-form-label pt-2">Full Name</label>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="Full Name"
                              v-model="data.description.members.member_3.name"

                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Email</label>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="email@gmail.com"
                              v-model="data.description.members.member_3.email"
                          />
                        </div>
                        <div class="col-6">
                          <label class="col-form-label pt-2">Highest Education</label>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="HSC"
                              v-model="data.description.members.member_3.highest_education"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  </fieldset>
                </form>
              </b-card-body>
              <h5 slot="header">Primary Info <b-badge class="text-normal ml-2" style="color:#d9c6c6"> {{data.status}}</b-badge>
                                                <router-link  class="ml-3" :to="`/participation/create-submission/false`" v-if="data.status=='Incomplete'">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                                </router-link>
              <br>
                <small><b-badge variant="success">{{raw_data.competition_stage}}</b-badge></small>

              </h5>

            </b-card>
            <b-card header-tag="div" no-body>

              <b-card-body >
                <form >
                  <fieldset :disabled="true" class="no-border" >
                    <div class="row">
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-6">
                            <label class="col-form-label pt-0">Title of Your Idea / Innovation  </label>
                            <input
                                class="form-control"
                                type="text"
                                required=""
                                placeholder="Team ONE"
                                v-model="data.description.idea.title"
                            />
                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">Brief Description of Your Idea (Max 150 words)
                            </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Details in brief" v-model="data.description.idea.brief_description"></textarea>
                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-6">
                            <label class="col-form-label pt-5">Problem Statement (Max 100 words)
                            </label>
                            <input
                                class="form-control"
                                type="text"
                                required=""
                                placeholder="Team ONE"
                                v-model="data.description.idea.problem_statement"
                            />
                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">Proposed Solution (Max 150 words)

                            </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Details in brief" v-model="data.description.idea.proposed_solution"></textarea>
                          </div>

                        </div>
                      </div>

                      <div class="col-md-12">
                        <label class="col-form-label pt-5">How does your idea relate to the following areas?
                          (Check all that apply)
                        </label>
                        <div class="form-check" v-for="option in areaOptions" :key="option">
                          <input class="form-check-input"
                                 type="checkbox"
                                 :value="option"
                                 v-model="data.description.idea.area">
                          <label class="form-check-label">{{ option }}</label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <label class="col-form-label pt-5">Implementation Area (Where will this idea be piloted?)
                        </label>
                        <div class="form-check" v-for="option in implementationAreaOptions" :key="option">
                          <input class="form-check-input"
                                 type="checkbox"
                                 :value="option"
                                 v-model="data.description.idea.implementation_area">
                          <label class="form-check-label">{{ option }}</label>
                        </div>
                      </div>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">Target Beneficiaries
                              Who will benefit from your solution? (e.g., households, waste workers, students)

                            </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Details in brief" v-model="data.description.idea.target_beneficiaries"></textarea>
                          </div>

                        </div>
                      </div>

                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-6">
                            <label class="col-form-label pt-5">Do you already have a prototype or concept model</label>
                            <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio5" :value="true" v-model="data.description.idea.prototype">Yes</b-form-radio>
                              </div>
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio5" :value="false" v-model="data.description.idea.prototype">No</b-form-radio>
                              </div>
                              <br>
                            </div>
                          </div>
                          <div class="col-6">
                            <label class="col-form-label pt-5">Has this idea been implemented or tested before</label>
                            <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio6" :value="true" v-model="data.description.idea.already_implemented">Yes</b-form-radio>
                              </div>
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio6" :value="false" v-model="data.description.idea.already_implemented">No</b-form-radio>
                              </div>
                              <br>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div class="col-md-12" v-if="data.description.idea.already_implemented">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">If yes, please describe where and what was the result (Max 100 words)  </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Banani, Dhaka" v-model="data.description.idea.existence"></textarea>
                          </div>

                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </b-card-body>
              <h5 slot="header">Idea</h5>
            </b-card>   <b-card header-tag="div" no-body>

              <b-card-body >
                <form >
                  <fieldset :disabled="true" class="no-border" >
                    <div class="row">
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-0">How do you plan to sustain this idea as a business?
                              Revenue model, cost structure, and scalability (Max 200 words)
                            </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Details in brief" v-model="data.description.sustainability.plan"></textarea>

                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">Do you currently have any funding or investment?
                            </label>
                            <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio8" :value="true" v-model="data.description.sustainability.funding">Yes</b-form-radio>
                              </div>
                              <div class="radio radio-primary d-inline-block">
                                <b-form-radio name="radio8" :value="false" v-model="data.description.sustainability.funding">No</b-form-radio>
                              </div>
                              <br>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-row">
                          <div class="col-12">
                            <label class="col-form-label pt-5">If yes, from whom?
                            </label>
                            <textarea class="form-control" rows="5"
                                      placeholder="Details in brief" v-model="data.description.sustainability.funding_details"></textarea>

                          </div>

                        </div>
                      </div>
                      <div class="col-md-12">
                        <label class="col-form-label pt-5">How does your idea relate to the following areas?
                          (Check all that apply)
                        </label>
                        <label class="col-form-label pt-5">What kind of support do you need?</label>
                        <div class="form-check" v-for="option in supportOptions" :key="option">
                          <input class="form-check-input"
                                 type="checkbox"
                                 :value="option"
                                 v-model="data.description.sustainability.support">
                          <label class="form-check-label">{{ option }}</label>
                        </div>

                      </div>
                      <span class="pt-5">Declaration
I certify that the information provided in this form is true and original. I understand that my idea, if selected, will be used solely for the purposes of the NextGen Water and Waste Innovation Challenge, and I will retain ownership unless otherwise agreed in writing. </span>
                      <div class="col-md-12">

                        <div class="form-row">
                          <div class="col-6">
                            <label class="col-form-label pt-2">Signature</label>
                            <input
                                class="form-control"
                                type="text"
                                required=""
                                placeholder="Samiur Rahman"
                                v-model="data.description.signature"
                            />
                          </div>

                        </div>
                      </div>

                      <span class="pt-5">
                          By Clicking Submit, I allow Catch Bangladesh, WaterAid, and Swisscontact to use my idea summary, name, and photos/videos (if selected) for campaign, documentation, or promotional purposes.
                        </span>
                    </div>
                  </fieldset>
                </form>
              </b-card-body>
              <h5 slot="header">Sustainability</h5>
            </b-card>

          </div>
          <div class="col-xl-4">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0"> Attachments   <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-modal.modal-scrollable-add-document v-b-tooltip.hover title="Add Documents"></feather>
                </h4>
              </div>
              <div>


                    <b-table show-empty sticky-header :items="attachment_list" :fields="submissionAttach" head-variant="light">
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(uploaded_at)="data">
                        {{ data.value.split('T')[0] }}
                      </template>

                      <template #cell(file)="data">
<!--                        <div v-if="data.item.attach_title">-->
                          <div class="d-flex flex-column">
                            <div v-if="data.item.file">
                              <b-badge>
                                <a :href="host+data.item.file" target="_blank" style="word-break: break-all; color: #d9c6c6;">View</a>

                              </b-badge>
                          </div>
                            <div v-else>
                              No File Given
                            </div>
                        </div>
                      </template>
                      <template #cell(links)="data">

<!--                        <div v-if="data.item.attach_title">-->
                          <div class="d-flex flex-column">
                            <div v-if="data.item.links">
                              <b-badge >
                                <a :href="data.item.links" target="_blank" style="word-break: break-all;color:#d9c6c6;">Visit</a>
                              </b-badge>
                          </div>
                            <div v-else>
                              No Links Given
                            </div>
                        </div>
                      </template>

                      <template #cell(action)="data">
                        <div style="display: flex; flex-direction: row; gap:10px">
                          <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                        </div>
                      </template>
                    </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-else>
      <div class="col">
        <b-card header-tag="div" no-body>

          <b-card-body>
            You have not submitted any proposal yet. <br>
            <div class="form-group mt-3 mb-0 col-4">

                <b-button @click="$router.push('/participation/create-submission/true')">
                  Submit now!
                </b-button>


            </div>
          </b-card-body>
          <h5 slot="header">Create Submission</h5>
        </b-card>

      </div>
    </div>
    <!-- Container-fluid Ends-->
    <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
      <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
        <div class="row">
          <div class="col-md-12">
                <label class="col-form-label pt-2">Title</label>
                <input
                    class="form-control"
                    type="text"
                    required=""
                    placeholder="Business Model"
                    v-model="title"
                />
          </div>
          <div class="col-md-12">
                <label class="col-form-label pt-2">Link</label>
                <input
                    class="form-control"
                    type="text"
                    required=""
                    placeholder="https://youtube.com"
                    v-model="link"
                />
          </div>
          <div class="col">
            <div class="form-group">

              <label>Upload project file</label>

              <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
            </div>
          </div>
        </div>

      </form>
    </b-modal>


  </div>
</template>

<script>

  import Datepicker from 'vuejs-datepicker';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';
  import { mapState } from 'vuex';
  import { host } from '../../_helpers/APIPath';
  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        host:host,
        active1:true,
        active2:false,
        active3:false,
        format: 'MM/dd/yyyy',
        submission_attachment:null,
        link:null,
        title:null,
        data:{
          stage:1,
          'description':{
            'first_name':null,
            'last_name':null,
            'date_of_birth':null,
            'gender':null,
            'id_number':null,
            'primary_email':null,
            'whatsapp_no':null,
            'current_address':null,
            'permanent_address':null,
            'highest_education':null,
            'team':false,
            'members':{
              member_1:{
                name:null,
                email:null,
                highest_education:null
              },
              member_2:{
                name:null,
                email:null,
                highest_education:null
              },member_3:{
                name:null,
                email:null,
                highest_education:null
              }

            },
            'idea': {
              'title': null,
              'brief_description': null,
              'problem_statement': null,
              'proposed_solution': null,
              'area': [],
              'implementation_area': [],
              'target_beneficiaries': null,
              'prototype': null,
              'already_implemented': null,
              'existence': null
            },
            'sustainability':{
              'plan':null,
              'funding':false,
              'funding_details':null,
              'support':[]
            },
            'signature':null,

          },
          'team_name':null,
          'status':'Incomplete'
        },
        numberSelectedFlatInput: 1,
        numberOptions: [
          { value: 1, text: 1 },
          { value: 2, text: 2 },
          { value: 3, text: 3 },
          { value: 4, text: 4 },
          { value: 5, text: 5 }
        ],
        supportOptions: [
          'Business Mentorship',
          'Seed Funding',
          'Technical Mentorship (WASH/Engineering)',
          'Legal or Policy Guidance',
          'Networking & Partnerships',
          'Branding & Communication',
          'Community Testing Opportunity'
        ],
        implementationAreaOptions: [
          'Satkhira Paurashava',
          'Shyamnagar',
          'Assasuni',
          'Dhamoirhat Paurashava',
          'Niamatpur'
        ],
        areaOptions: [
          'Solid Waste Management',
          'Integrated Water Resource Management',
          'Climate Resilience',
          'Public Service Innovation',
          'Youth Engagement',
          'Digital or Tech-based Solution'
        ],
        smsCount: '',
        data_exists: false,
        raw_data:null,
        attachment_list:[],
        submissionAttach: [
          {
            key: 'index',
            label: '#'
          },
          {
            key: 'title',
            label: 'Title',
            sortable: false
          },
          {
            key: 'file',
            label: 'File',
            sortable: false
          },
          {
            key: 'links',
            label: 'Link',
            sortable: false
          },{
            key: 'uploaded_at',
            label: 'Updated_at',
            sortable: false
          },
          {
            key: 'action',
            label: 'Action',
            sortable: false,
          }
        ]
      };
    },

    computed: {
      ...mapState({
        attachment:state => state.submission.attachment,

      })
    },
    watch:{
      attachment(oldValue, newValue) {
        this.attachment_list = this.attachment;
        // this.assignedProjectMembers = this.project_detail.teammates
      }
    },

    created() {


      this.$store.dispatch('submission/fetchMySubmissionDetail').then(response => {


        if (response.data) {
          this.data_exists = true;
          this.raw_data = response.data;
          this.data.description = response.data.description;
          this.data.status = response.data.status;
          console.log(response.data.description.idea);
          if (!response.data.description.idea) {
            this.data.description.idea = {
              'title': null,
              'brief_description': null,
              'problem_statement': null,
              'proposed_solution': null,
              'area': [],
              'implementation_area': [],
              'target_beneficiaries': null,
              'prototype': null,
              'already_implemented': null,
              'existence': null
            };
          }
          if (!response.data.description.sustainability) {
            this.data.description.sustainability = {
              'plan': null,
              'funding': null,
              'funding_details': null,
              'support': []
            };
          }
          this.data.stage = response.data.stage;
          this.data.team_name = response.data.team_name;
          console.log(this.data.stage);
          if (this.data.stage == 1) {
            this.active2 = true;
            this.active3 = false;
          } else if (this.data.stage == 2) {
            this.active3 = true;
          }
          this.$store.dispatch('submission/fetchAttachmentList',this.raw_data.id)
        }

      });
      window.go(0)



    },
    methods: {
      getCharacterCount() {
        return this.smsCount.length;
      },
      uploadAttachFile(e) {
        console.log(e);
        this.submission_attachment = e.target.files[0];
        console.log('attachment,', this.submission_attachment);
      },
      handleAttachOk(bvModalEvent) {
        bvModalEvent.preventDefault();
        this.handleAttahmentSubmit();
      },

      handleAttahmentSubmit() {
        let payload={
          submission: this.raw_data.id,
          title: this.title
        };
        if(this.link){
          payload.links = this.link;
        }
        if(this.submission_attachment){
          payload.file = this.submission_attachment;
        }

        this.$store.dispatch('submission/addAttachment',payload).then(response => {
          console.log(response.code);
          if (response.code == 201) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });
            this.submission_attachment = null;
            this.link = null;
            this.title = null;
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });

        this.$nextTick(() => {
          this.$bvModal.hide('modal-scrollable-add-document');
        });
      },
      deleteAttach(id) {
        this.$store.dispatch("submission/deleteAttachment", {
          id: id,
          submission: this.raw_data.id
        }).then(response => {
          if (response.code == 200) {
            Swal.fire({
              title: "Success!",
              text: response.response,
              icon: "success"
            });
            this.delete_value = null
          } else {
            Swal.fire({
              title: "Error!",
              text: response.response,
              icon: "error"
            });
          }
        })
      },



    }
  };
</script>
<style scoped>
.form-disabled {
  pointer-events: none;
  opacity: 0.6; /* optional for visual feedback */
}
.no-border {
  border: none;
  padding: 0;
  margin: 0;
}
</style>
